import { event } from 'vue-gtag'

export function useSocialTrack() {
    return {
        trackSocial(platform, url) {
            event('social_click', {
                platform,
                url
            })
        }
    }
}